// NOTE: このファイルはまだちゃんとレビューされていません。コードの書き方を真似しないでください。
import type { FC } from "react"

import { cx } from "./utils"

import styles from "../TaigaPage.module.scss"

type ActionButtonProps = {
	label: string
	shortcut?: string
	variant: "primary" | "outline" | "success"
	onClick: () => void
}

const ActionButton: FC<ActionButtonProps> = ({
	label,
	shortcut,
	variant,
	onClick,
}) => (
	<button
		type="button"
		className={cx(styles.actionButton, styles[variant])}
		onClick={(event) => {
			event.stopPropagation()
			onClick()
		}}
	>
		<span>{label}</span>
		{shortcut !== undefined && (
			<span className={styles.shortcutChip}>{shortcut}</span>
		)}
	</button>
)

export default ActionButton
